import plane from "../../assets/images/Plane.svg"
import map from "../../assets/images/map.svg"
import AddAircraftModal from "../../components/Modal/AddAircraftModal";
import AddFlightManual from "../../components/Modal/AddFlightManual";
import AddFlightModal from "../../components/Modal/AddFlightModal";
import LayoutProvider from "../../providers/LayoutProvider";
import "./Home.css"
import React from "react";
import { Chart as ChartJS, CategoryScale, ArcElement, Tooltip, BarElement, Legend, LinearScale, } from "chart.js";
// import { Doughnut, Bar } from "react-chartjs-2";
import Chart from 'react-apexcharts';
import 'apexcharts';
import { BiImport } from "react-icons/bi"
import { getChart, getStats } from "../../components/Axios/Axios";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { getUser } from "../../store/slices/auth-slice";

ChartJS.register(CategoryScale, LinearScale, ArcElement, Tooltip, Legend, BarElement);
function Home() {
    const [showNestedList, setShowNestedList] = React.useState(false);
    const [aircraftNestedList, setAircraftNestedList] = React.useState(false);
    const [addFlight, setAddFlight] = React.useState(false);
    const [addAircraft, setAddAircraft] = React.useState(false);
    const [isAutoModalOpen, setIsAutoModalOpen] = React.useState(false);
    const [isManualModalOpen, setIsManualModalOpen] = React.useState(false);
    const [totalHours, setTotalHours] = React.useState("");
    const [day, setDay] = React.useState("")
    const [night, setNight] = React.useState("")
    const [pic, setPic] = React.useState("")
    const [sic, setSic] = React.useState("")
    const [crossCountry, setCrossCountry] = React.useState("")
    const [asInstructor, setAsInstructor] = React.useState("")
    const [totalFlights, setTotalFlights] = React.useState("")
    const [totalAircrafts, setTotalAircrafts] = React.useState("")
    const [groundSim, setGroundSim] = React.useState("")
    const [landingTotal, setLandingTotal] = React.useState("")
    const [landingDay, setLandingDay] = React.useState("")
    const [landingNight, setLandingNight] = React.useState("")
    const [monthlyFlightsData, setMonthlyFlightsData] = React.useState([]);
    const currentUser = useSelector(getUser)
    const handleOpenAuto = () => {
        setIsAutoModalOpen(true);
        setIsManualModalOpen(false);
    };

    const handleOpenManual = () => {
        setIsAutoModalOpen(false);
        setIsManualModalOpen(true);
    };

    const handleCloseAuto = () => {
        setIsAutoModalOpen(false);
    };

    const handleCloseManual = () => {
        setIsManualModalOpen(false);
    };
    const handleAddAircraft = () => {
        setAddAircraft(true);
    };

    const handleCloseAircraft = () => {
        setAddAircraft(false);
    };

    const handleToggleAircraftList = () => {
        setAircraftNestedList(!aircraftNestedList);
    };

    const handleToggleNestedList = () => {
        setShowNestedList(!showNestedList);
    };



    const rating1 = {
        datasets: [{
            data: [60, 40],
            backgroundColor: ['#00af80', '#f2f2f2'],
            cutout: '80%'
        }]
    };

    const rating2 = {
        datasets: [{
            data: [85, 15],
            backgroundColor: ['#00af80', '#f2f2f2'],
            cutout: '80%'
        }]
    };

    const rating3 = {
        datasets: [{
            data: [70, 30],
            backgroundColor: ['#00af80', '#f2f2f2'],
            cutout: '80%'
        }]
    };

    const rating4 = {
        datasets: [{
            data: [30, 70],
            backgroundColor: ['#00af80', '#f2f2f2'],
            cutout: '80%'
        }]
    };

    const [chartOptions, setChartOptions] = React.useState({
        chart: {
            id: 'bar-chart',
            toolbar: {
                show: true,
            },

            dataLabels: {
                enabled: false,
            },

        },
        xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
        },
        colors: ['#00af80'],

        dataLabels: {
            enabled: false,
        },

        plotOptions: {
            bar: {
                columnWidth: 40, // Set your desired width here
            },
        },

    });

    const [chartSeries, setChartSeries] = React.useState([
        {
            name: 'Flights',
            data: [440, 550, 410, 640, 220, 450, 348, 780, 320, 900, 210, 1000],
        },
    ]);


    const fetchStats = async () => {

        try {
            const data = await getStats();
            const data2 = await getChart(currentUser._id)
            setMonthlyFlightsData(data2?.data || "");
            console.log("stats", data)
            setTotalHours(data?.filight?.filightStats[0]?.totalHours?.toFixed(2) || 0);
            setDay(data?.filight?.filightStats[0]?.day?.toFixed(2) || 0);
            setNight(data?.filight?.filightStats[0]?.night?.toFixed(2) || 0)
            setPic(data?.filight?.filightStats[0]?.pic?.toFixed(2) || 0)
            setSic(data?.filight?.filightStats[0]?.sic?.toFixed(2) || 0)
            setCrossCountry(data?.filight?.filightStats[0]?.crossCountry?.toFixed(2) || 0)
            setLandingTotal(data?.filight?.filightStats[0]?.landAndApp_totalLandings?.toFixed(2) || 0)
            setLandingNight(data?.filight?.filightStats[0]?.landAndApp_fullStopNight?.toFixed(2) || 0)
            setGroundSim(data?.filight?.filightStats[0]?.groundSim?.toFixed(2) || 0)
            setAsInstructor(data?.filight?.filightStats[0]?.ActlInst?.toFixed(2) || 0)
            setTotalFlights(data?.filight?.filightStats[0]?.totalFlight || 0)
            setTotalAircrafts(data?.aircraft?.totalAircraftModel || 0 );

        }
        catch (error) {
            console.error("Error adding flight", error);
        }

    }

    React.useEffect(() => {
        fetchStats();
    }, []);



    return (
        <LayoutProvider>
            {/* <section style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between" }}>
                <h4 className="dashboard_heading">Dashboard</h4>
                <h6 className="dashboard_subheading">Dashboard {">"} Home</h6>
            </section> */}
            <section
                style={{
                    background: "#DDEBFC",
                    paddingRight: "20px",
                    paddingLeft: "20px",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                    borderRadius: "6px",
                }}
            >
                <h4
                    className="heading3"
                    style={{ fontWeight: "600" }}
                >
                    Welcome back, {currentUser?.firstname}{" "}
                </h4>
                <p className="heading4" style={{ marginBottom: "0px" }}>
                    Manage your flights and see your currency and totals. You can also
                    upload or download your logbook, and get a printer-optimized view!
                </p>
            </section>
            <div className="quick_action_sec">
                <section>
                    <ul className="btn_list">
                        <li
                            className="heading4"
                            style={{ fontWeight: "600" }}
                        >
                            {" "}
                            Quick Actions
                        </li>
                        <li>
                            <button className="q_action_btn flight_btn" onClick={handleOpenAuto}>+ Add Flight</button>
                        </li>
                        {isAutoModalOpen && (
                            <AddFlightModal
                                open={isAutoModalOpen}
                                onCloseFm={handleCloseAuto}
                                onOpenManual={handleOpenManual}
                            />
                        )}

                        {isManualModalOpen && (
                            <AddFlightManual
                                open={isManualModalOpen}
                                onCloseFm={handleCloseManual}
                                onOpenAuto={handleOpenAuto}
                            />
                        )}
                        <li>
                            <button className="q_action_btn aircraft_btn" onClick={handleAddAircraft}>+ Add Aircraft</button>
                        </li>
                        <AddAircraftModal
                            open={addAircraft}
                            onClose={handleCloseAircraft}
                        />
                        {/* <li>
                            <button className="q_action_btn airport_btn">+ Add Airport</button>
                        </li> */}
                        <li>
                            <button className="q_action_btn import_btn"><BiImport /><Link style={{ color: "white", textDecoration: "none" }} to="/logbook/import">Import/Export</Link> </button>
                        </li>
                    </ul>
                </section>
                <section>
                    {/* <div style={{ display: "flex", gap: "20px" }}>
                        <section className="plane_section">
                            <img src={plane} style={{ width: "50px" }} alt="Plane Logo" />
                            <ul style={{ listStyle: "none", paddingLeft: "5%" }}>
                                <li className="heading5 text_color2">Total Hours</li>
                                <li className="heading-3 text">{totalHours}</li>
                                <li className="heading5 secondary">View Details</li>
                            </ul>
                        </section>
                        <section className="plane_section">
                            <img src={plane} style={{ width: "50px" }} alt="Plane Logo" />
                            <ul style={{ listStyle: "none", paddingLeft: "5%" }}>
                                <li className="heading5 text_color2">Aircrafts</li>
                                <li className="heading-3 text">{totalAircrafts}</li>
                                <li className="heading5 secondary">View Details</li>
                            </ul>
                        </section>
                        <section className="plane_section">
                            <img src={plane} style={{ width: "50px" }} alt="Plane Logo" />
                            <ul style={{ listStyle: "none", paddingLeft: "5%" }}>
                                <li className="heading5 text_color2">Flights</li>
                                <li className="heading-3 text">{totalFlights}</li>
                                <li className="heading5 secondary">View Details</li>
                            </ul>
                        </section>
                    </div> */}
                    {/* <div style={{ display: "flex", gap: "20px" }}>
                       
                        <section className="plane_section" style={{ margin: "0px" }}>
                            <img src={plane} style={{ width: "50px" }} alt="Plane Logo" />
                            <ul style={{ listStyle: "none", paddingLeft: "5%" }}>
                                <li className="heading5 text_color2">Airports</li>
                                <li className="heading-3 text">125</li>
                                <li className="heading5 secondary">View Details</li>
                            </ul>
                        </section>
                    </div> */}
                    <section className="plane_section">
                        <section style={{ width: "100%" }}>
                            <h4 className="heading-4">Quick Report</h4>
                            <div className="report_row">
                                <div className="report_box">
                                    <p>Total Flights</p>
                                    <h3>{totalFlights}</h3>
                                </div>
                                <div className="report_box">
                                    <p>Total Aircrafts</p>
                                    <h3>{totalAircrafts}</h3>
                                </div>
                                <div className="report_box">
                                    <p>Total Hours</p>
                                    <h3>{totalHours}</h3>
                                </div>
                                <div className="report_box">
                                    <p>Day</p>
                                    <h3>{day}</h3>
                                </div>
                                <div className="report_box">
                                    <p>Nights</p>
                                    <h3>{night}</h3>
                                </div>
                            </div>
                            <div className="report_row">
                                <div className="report_box">
                                    <p>Total Landing</p>
                                    <h3>{landingTotal}</h3>
                                </div>
                                <div className="report_box">
                                    <p>Pilot In Command</p>
                                    <h3>{pic}</h3>
                                </div>
                                <div className="report_box">
                                    <p>Second In Command</p>
                                    <h3>{sic}</h3>
                                </div>
                                <div className="report_box">
                                    <p>Ground Simulator</p>
                                    <h3>{groundSim}</h3>
                                </div>
                                <div className="report_box">
                                    <p>Cross County</p>
                                    <h3>{crossCountry}</h3>
                                </div>
                            </div>
                            {/* <div className="report_row">
                                <div className="report_box">
                                    <p>Day Landing</p>
                                    <h3>{landingDay}</h3>
                                </div>
                                <div className="report_box">
                                    <p>Night Landing</p>
                                    <h3>{landingNight}</h3>
                                </div>
                               
                            </div> */}
                        </section>
                    </section>
                </section>
                {/* 
                <section>
                    <div className="rating_sec">
                        <h4 className="heading-4">Rating Overview</h4>
                        <div className="rating_boxes">
                            <div className="rating_box">
                                <Doughnut width={"70%"} data={rating1} />
                                <h4 className="heading-4" style={{ textAlign: 'center' }}>Rating 1</h4>
                            </div>
                            <div className="rating_box">
                                <Doughnut width={"70%"} data={rating2} />
                                <h4 className="heading-4" style={{ textAlign: 'center' }}>Rating 1</h4>
                            </div>
                            <div className="rating_box">
                                <Doughnut width={"70%"} data={rating3} />
                                <h4 className="heading-4" style={{ textAlign: 'center' }}>Rating 1</h4>
                            </div>
                            <div className="rating_box">
                                <Doughnut width={"100%"} height={"200"} data={rating4} />
                                <h4 className="heading-4" style={{ textAlign: 'center' }}>Rating 1</h4>
                            </div>
                        </div>
                    </div>
                </section> */}
            </div>
            <div className="dash_count_admin" style={{ marginTop: "1%" }}>
                <h4 className="heading2">Monthly Flights</h4>
                <Chart
                    options={{
                        ...chartOptions,
                        xaxis: {
                            categories: Object.keys(monthlyFlightsData),
                        },
                    }}
                    series={[
                        {
                            name: 'Flights',
                            data: Object.values(monthlyFlightsData),
                        },
                    ]}
                    type="bar"
                    height={350}
                />
                 {/* <Chart options={chartOptions} series={chartSeries} type="bar" height={300} /> */}
            </div>
        </LayoutProvider >
    );
}

export default Home;